function extractAllKeys(input) {
  const dataArray = Array.isArray(input) ? input : [input];
  const keySet = new Set();

  function recurse(obj, prefix = '') {
    for (const key in obj) {
      const fullKey = prefix ? `${prefix}.${key}` : key;
      keySet.add(fullKey);
      if (typeof obj[key] === 'object' && obj[key] !== null && !Array.isArray(obj[key])) {
        recurse(obj[key], fullKey);
      }
    }
  }

  dataArray.forEach(item => {
    if (typeof item === 'object' && item !== null) {
      recurse(item);
    }
  });

  console.log(keySet, "keySet")

  return Array.from(keySet);
}


export default extractAllKeys